import { Text, View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import { COLORS } from '@app/constants';
import { useToken, useWindowDimensions } from '@app/hooks';
import React, { useContext, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CButton } from '../../../../../../components/Common';
import { useTradeSetting } from '../../../../../../hooks/trade/tradeSetting';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import { useTradePosition } from '../../../../../../hooks/trade/tradePosition';
import CrossModalFooter from './CrossModalFooter';
import CrossModalHeader from './CrossModalHeader';
import CrossSliderBar from './CrossSliderBar';
import { CrossModalDescriptionBox, CrossModalWrapper } from './styles';

const CrossModal = ({ setShowModal }) => {
  const { borderColor, textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const wSize =
    width < 772
      ? width / 1.1
      : width < 1400
        ? width < 900
          ? width / 2
          : width / 3
        : width / 4;

  const CROSS = 'cross';
  const ISO = 'iso';
  const tabs = [CROSS, ISO];

  const { data: tradeStore, mutate: mutateTradeStore } = useTradeStore();
  const { data: tradeSetting, mutate: mutateTradeSetting } = useTradeSetting(
    tradeStore.ep_id
  );
  const { data: positions } = useTradePosition();

  // 현재 종목의 포지션이 있으면 해당 포지션의 설정 사용
  const currentPosition = useMemo(() =>
    positions?.find((pos: any) => +pos.exchange_pairs_id === +tradeStore?.ep_id),
    [positions, tradeStore?.ep_id]
  );

  const initialCrossIso = currentPosition?.cross_iso ?? tradeSetting?.cross_iso;
  const initialLeverage = currentPosition?.leverage ?? tradeSetting?.leverage;

  const [tab, setTab] = useState(initialCrossIso === 'C' ? CROSS : ISO);

  const [leverage, setLeverage] = useState(initialLeverage);

  return (
    <CrossModalWrapper style={{ width: wSize }}>
      <CrossModalHeader closeModal={() => setShowModal(false)} />
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        {tabs?.map((item, index) => (
          <CButton
            key={index.toString()}
            title={item && t(item)}
            onClick={() => setTab(item)}
            style={{
              background: item === tab ? COLORS.primary : 'transparent',
              border: item !== tab ? `1px solid ${borderColor}` : 'none',
              height: 38,
              width: '48%',
              justifyContent: 'center',
              alignItems: 'center',
              color: item === tab ? COLORS.white : textw,
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: item === tab ? 600 : 500,
            }}
          />
        ))}
      </View>

      <View style={{ width: '100%', marginTop: 20 }}>
        <CrossSliderBar
          leverage={leverage}
          setLeverage={setLeverage}
          maxLeverage={tradeStore.max_leverage}
        />
        {/* {leverage > 21 ? (
          <Text
            style={{
              marginTop: 25,
              color: '#007AFF',
              fontSize: 12,
              lineHeight: '14px',
              fontWeight: '500'
            }}
          >
            {t("crossLeverageDangerText")}
          </Text>
        ) : null} */}
        <CrossModalDescriptionBox
          style={{
            background: 'transparent',
          }}
        >
          <Text size={13} style={{ lineHeight: '1.6', fontWeight: 400 }}>
            {tab === CROSS
              ? t('crossModalDescription')
              : t('isoModalDescription')}
          </Text>
        </CrossModalDescriptionBox>

        <CrossModalFooter
          ep_id={tradeStore.ep_id}
          cross_iso={tab === CROSS ? 'C' : 'I'}
          leverage={leverage}
          closeModal={() => setShowModal(false)}
          // handleConfirm={() => handleConfirm()}
        />
      </View>
    </CrossModalWrapper>
  );
};

export default React.memo(CrossModal);
